import { VendorProfileScreen } from "@/features/vendor/dashboard";

export default VendorProfileScreen;
